const productsData = {
    clothing: [
        {
            productName: 'GOT T-SHIRT',
            productPrice: 129,
            productPopularity: 0,
            productId: 'black',
            image: 'images/tshirt3.png',
            image2: 'images/tshirt2.png',
            image3: 'images/tshirt1.png',
            image4: 'images/tshirt4.png',
            image5: 'images/tshirt5.png',
            productDescription:
                'This classic black t-shirt is made from 100% high-quality cotton, offering superior comfort and durability. The minimalist design features a crew neckline and a regular fit, making it a versatile addition to any wardrobe.',
        },
        {
            productName: 'HOODIE',
            productPrice: 149,
            productPopularity: 0.5,
            productId: 'beige',
            image: 'images/hoodie1.jpg',
            image2: 'images/hoodie6.jpg',
            image3: 'images/hoodie5.jpg',
            image4: 'images/hoodie4.jpg',
            image5: 'images/hoodie2.jpg',
            productDescription:
                'Stay cozy and stylish with our beige hoodie, made from a soft cotton blend. This hoodie features a relaxed fit, kangaroo pocket, and adjustable drawstrings for maximum comfort. Perfect for casual wear or layering on cooler days.',
        },
        {
            productName: 'DRESS',
            productPrice: 149,
            productPopularity: 15,
            productId: 'yellow',
            image: 'images/dressYellow1.jpg',
            image2: 'images/dressYellow3.jpg',
            image3: 'images/dressYellow4.jpg',
            image4: 'images/dressYellow2.jpg',
            image5: 'images/dressYellow5.jpg',
            productDescription:
                'Make a statement with our vibrant yellow dress. Crafted from a lightweight, breathable fabric, this dress is designed for both comfort and style. It features a flattering A-line silhouette, short sleeves, and a knee-length hem, making it suitable for various occasions',
        },
        {
            productName: 'JUMPSUIT',
            productPrice: 219,
            productPopularity: 19,
            productId: 'green',
            image: 'images/jumpsuit1.jpg',
            image2: 'images/jumpsuit2.jpg',
            image3: 'images/jumpsuit3.jpg',
            image4: 'images/jumpsuit4.jpg',
            image5: 'images/jumpsuit5.jpg',
            productDescription:
                'Our green jumpsuit is the epitome of chic and comfort. Made from a soft, stretchy material, it offers a flattering fit with a cinched waist and wide-leg pants. The sleeveless design and v-neckline add a touch of elegance, perfect for both casual and formal events.',
        },
        {
            productName: 'GOT T-SHIRT',
            productPrice: 119,
            productPopularity: 1,
            productId: 'white',
            image: 'images/tshirtWhite3.png',
            image2: 'images/tshirtWhite2.png',
            image3: 'images/tshirtWhite1.png',
            image4: 'images/tshirtWhite4.png',
            image5: 'images/tshirtWhite5.png',
            productDescription:
                'This classic white t-shirt is made from 100% high-quality cotton, offering superior comfort and durability. The minimalist design features a crew neckline and a regular fit, making it a versatile addition to any wardrobe.',
        },
        {
            productName: 'HOODIE',
            productPrice: 119,
            productPopularity: 1.5,
            productId: 'pink',
            image: 'images/pinkHoodie2.jpg',
            image2: 'images/pinkHoodie1.jpg',
            image3: 'images/pinkHoodie3.jpg',
            image4: 'images/pinkHoodie4.jpg',
            image5: 'images/pinkHoodie6.jpg',
            productDescription:
                'Add a pop of color to your wardrobe with our pink hoodie. Made from a plush, fleece-lined fabric, this kangaroo hoodie provides warmth and comfort. It features a front pocket and adjustable drawstrings, making it ideal for everyday wear.',
        },
        {
            productName: 'DRESS',
            productPrice: 190,
            productPopularity: 3,
            productId: 'blue',
            image: 'images/dressBlue1.jpg',
            image2: 'images/dressBlue5.jpg',
            image3: 'images/dressBlue4.jpg',
            image4: 'images/dressBlue3.jpg',
            image5: 'images/dressBlue2.jpg',
            productDescription:
                'Our blue dress combines elegance with simplicity. Made from a soft, flowy fabric, it features a fitted bodice and a flared skirt that falls just above the knee. The dress has long sleeves and a round neckline, perfect for both day and night outings.',
        },
        {
            productName: 'SWEATSHIRT',
            productPrice: 159,
            productPopularity: 5,
            productId: 'gray',
            image: 'images/sweatshirtGray1.png',
            image2: 'images/sweatshirtGray2.png',
            image3: 'images/sweatshirtGray3.png',
            image4: 'images/sweatshirtGray4.png',
            image5: 'images/sweatshirtGray5.png',
            productDescription:
                'This classic gray sweatshirt is perfect for any casual occasion. Made from a soft and durable cotton blend, it provides both comfort and warmth. It features a crew neckline, ribbed cuffs, and a relaxed fit, making it an essential piece for your wardrobe.',
        },
        {
            productName: 'TROUSERS',
            productPrice: 149,
            productPopularity: 6,
            productId: 'black',
            image: 'images/trousers1.jpg',
            image2: 'images/trousers2.jpg',
            image3: 'images/trousers3.jpg',
            image4: 'images/trousers4.jpg',
            image5: 'images/trousers5.jpg',
            productDescription:
                'Elevate your everyday look with these stylish black trousers. Crafted from high-quality fabric, they offer a slim fit that flatters all body types. Featuring a button and zip closure, belt loops, and functional pockets, these trousers are both practical and fashionable.',
        },
        {
            productName: 'SWEATSHIRT',
            productPrice: 199,
            productPopularity: 8,
            productId: 'black',
            image: 'images/sweatshirtBlack1.png',
            image2: 'images/sweatshirtBlack4.png',
            image3: 'images/sweatshirtBlack3.png',
            image4: 'images/sweatshirtBlack2.png',
            image5: 'images/sweatshirtBlack5.png',
            productDescription:
                'Our black sweatshirt combines comfort with a sleek design. Made from premium cotton, it offers a soft feel and a relaxed fit. The sweatshirt features a crew neckline and ribbed cuffs, making it ideal for layering or wearing on its own.',
        },
        {
            productName: 'DRESS',
            productPrice: 249,
            productPopularity: 12,
            productId: 'puffy',
            image: './images/dressWhite1.png',
            image2: './images/dressWhite2.png',
            image3: './images/dressWhite3.png',
            productDescription:
                'Stand out in our elegant white puffy dress. Made from lightweight, breathable fabric, this dress features a fitted bodice and a voluminous skirt that falls just above the knee. The short sleeves and round neckline add a touch of sophistication, perfect for special occasions.',
        },
        {
            productName: 'JEANS',
            productPrice: 149,
            productPopularity: 55,
            productId: 'dark',
            image: 'images/jeans4.jpg',
            image2: 'images/jeans1.jpg',
            image3: 'images/jeans5.jpg',
            image4: 'images/jeans3.jpg',
            image5: 'images/jeans2.jpg',
            productDescription:
                'Our dark jeans are a versatile addition to any wardrobe. Made from high-quality denim, they offer a comfortable fit with just the right amount of stretch. These jeans feature a classic five-pocket design, a button and zip fly, and a tapered leg for a modern look.',
        },
        {
            productName: 'DRESS',
            productPrice: 229,
            productPopularity: 13,
            productId: 'fancy',
            image: 'images/dressFancy1.jpg',
            image2: 'images/dressFancy3.jpg',
            image3: 'images/dressFancy4.jpg',
            image4: 'images/dressFancy2.jpg',
            image5: 'images/dressFancy5.jpg',
            productDescription:
                'Make a statement with our fancy dress. Designed with intricate detailing, this dress features a fitted bodice and a flowing skirt that falls to mid-calf. The dress is made from luxurious fabric, with a v-neckline and short sleeves, perfect for elegant events.',
        },
        {
            productName: 'T-SHIRT',
            productPrice: 149,
            productPopularity: 15,
            productId: 'white',
            image: 'images/tShirtWhite3.jpg',
            image2: 'images/tShirtWhite2.jpg',
            image3: 'images/tShirtWhite5.jpg',
            image4: 'images/tShirtWhite1.jpg',
            image5: 'images/tShirtWhite4.jpg',
            productDescription:
                'This classic white t-shirt is an essential for any wardrobe. Made from 100% soft, breathable cotton, it offers a comfortable fit and versatile style. It features a crew neckline and short sleeves, perfect for layering or wearing on its own.',
        },
        {
            productName: 'JEANS',
            productPrice: 149,
            productPopularity: 55,
            productId: 'light',
            image: 'images/jeansLight1.jpg',
            image2: 'images/jeansLight3.jpg',
            image3: 'images/jeansLight2.jpg',
            image4: 'images/jeansLight4.jpg',
            image5: 'images/jeansLight5.jpg',
            productDescription:
                'Our light jeans offer a casual and comfortable look. Made from high-quality denim, they feature a classic five-pocket design, a button and zip fly, and a slim fit that flatters all body types. Perfect for everyday wear.',
        },
        {
            productName: 'DRESS',
            productPrice: 229,
            productPopularity: 14,
            productId: 'colorful',
            image: 'images/dressColorful1.jpg',
            image2: 'images/dressColorful3.jpg',
            image3: 'images/dressColorful4.jpg',
            image4: 'images/dressColorful2.jpg',
            image5: 'images/dressColorful5.jpg',
            productDescription:
                'Stand out in our colorful dress. Crafted from lightweight, breathable fabric, this dress features a vibrant print, short sleeves, and a hemline that falls just above the knee. Perfect for adding a splash of color to your wardrobe.',
        },
        {
            productName: 'SHIRT',
            productPrice: 119,
            productPopularity: 16,
            productId: 'striped',
            image: 'images/shirt1.png',
            image2: 'images/shirt4.png',
            image3: 'images/shirt2.png',
            image4: 'images/shirt3.png',
            image5: 'images/shirt5.png',
            productDescription:
                'Add a touch of sophistication with our striped shirt. Made from a soft cotton blend, it features a classic button-down design, long sleeves, and a regular fit. The vertical stripes add a stylish twist to a timeless piece.',
        },
        {
            productName: 'HOODIE',
            productPrice: 249,
            productPopularity: 18,
            productId: 'black',
            image: 'images/blackHoodie1.jpg',
            image2: 'images/blackHoodie2.jpg',
            image3: 'images/blackHoodie3.jpg',
            image4: 'images/blackHoodie4.jpg',
            image5: 'images/blackHoodie5.jpg',
            productDescription:
                'Our black hoodie is a must-have for any casual wardrobe. Made from a soft, fleece-lined fabric, it offers warmth and comfort. It features a kangaroo pocket, adjustable drawstrings, and a relaxed fit, perfect for everyday wear.',
        },
        {
            productName: 'SWEATSHIRT',
            productPrice: 249,
            productPopularity: 20,
            productId: 'light',
            image: 'images/sweatshirtLight.png',
            image2: 'images/sweatshirtLight4.png',
            image3: 'images/sweatshirtLight3.png',
            image4: 'images/sweatshirtLight2.png',
            image5: 'images/sweatshirtLight5.png',
            productDescription:
                'Stay cozy with our light sweatshirt. Made from a soft cotton blend, it features a crew neckline, ribbed cuffs, and a relaxed fit. The neutral color makes it easy to pair with any outfit, providing both style and comfort.',
        },
        {
            productName: 'SHIRT',
            productPrice: 119,
            productPopularity: 17,
            productId: 'dotted',
            image: 'images/shirtDotted1.png',
            image2: 'images/shirtDotted5.png',
            image3: 'images/shirtDotted2.png',
            image4: 'images/shirtDotted4.png',
            image5: 'images/shirtDotted6.png',
            productDescription:
                'Make a statement with our dotted shirt. Crafted from a lightweight, breathable fabric, it features a playful polka dot pattern, a classic button-down design, and long sleeves. Perfect for adding a fun element to your wardrobe.',
        },
        {
            productName: 'DRESS',
            productPrice: 229,
            productPopularity: 9,
            productId: 'azure',
            image: 'images/dressAzure1.jpg',
            image2: 'images/dressAzure2.jpg',
            image3: 'images/dressAzure3.jpg',
            image4: 'images/dressAzure4.jpg',
            productDescription:
                'Our azure dress combines elegance with simplicity. Made from a soft, flowy fabric, it features a fitted bodice and a flared skirt that falls just above the knee. The dress has short sleeves and a round neckline, ideal for both day and night outings.',
        },
        {
            productName: 'T-SHIRT',
            productPrice: 119,
            productPopularity: 11,
            productId: 'blue',
            image: 'images/tshirtBlue1.png',
            image2: 'images/tshirtBlue2.png',
            image3: 'images/tshirtBlue3.png',
            image4: 'images/tshirtBlue4.png',
            image5: 'images/tshirtBlue5.png',
            productDescription:
                'This stylish blue t-shirt is a versatile addition to any wardrobe. Made from 100% soft, breathable cotton, it provides all-day comfort. It features a classic crew neckline and short sleeves, perfect for both casual and active wear.',
        },
        {
            productName: 'T-SHIRT',
            productPrice: 139,
            productPopularity: 12,
            productId: 'gradient',
            image: 'images/tshirtGradient1.png',
            image2: 'images/tshirtGradient2.png',
            image3: 'images/tshirtGradient3.png',
            image4: 'images/tshirtGradient4.png',
            image5: 'images/tshirtGradient5.png',
            productDescription:
                'Stand out with our gradient t-shirt. Made from a lightweight, breathable fabric, this t-shirt features a unique gradient design that transitions smoothly from one color to another. It has a crew neckline and short sleeves, adding a modern twist to a classic style.',
        },
        {
            productName: 'DRESS',
            productPrice: 239,
            productPopularity: 19,
            productId: 'black',
            image: 'images/dressBlack1.jpg',
            image2: 'images/dressBlack3.jpg',
            image3: 'images/dressBlack4.jpg',
            image4: 'images/dressBlack2.jpg',
            productDescription:
                'Our elegant black dress is perfect for any special occasion. Made from a luxurious, flowy fabric, it features a fitted bodice and a flared skirt that falls just above the knee. The dress has short sleeves and a round neckline, offering a timeless and sophisticated look.',
        },
    ],
    accessories: [
        {
            productName: 'SOCKS',
            productPrice: 29,
            productPopularity: 1,
            productId: 'white',
            image: 'images/socks3.jpg',
            image2: 'images/socks1.jpg',
            image3: 'images/socks4.jpg',
            image4: 'images/socks2.jpg',
            productDescription:
                'These white socks are a wardrobe essential, providing both comfort and style. Made from a soft, breathable cotton blend, they ensure all-day comfort and durability. Perfect for everyday wear or athletic activities.',
        },
        {
            productName: 'RUCKSACK',
            productPrice: 129,
            productPopularity: 2,
            productId: 'brown',
            image: 'images/rucksack1.jpg',
            image2: 'images/rucksack3.jpg',
            image3: 'images/rucksack2.jpg',
            productDescription:
                'This stylish brown rucksack combines functionality with a classic design. Crafted from durable materials, it features multiple compartments for organized storage and adjustable straps for comfort. Ideal for daily use or weekend adventures.',
        },
        {
            productName: 'BAG',
            productPrice: 49,
            productPopularity: 3,
            productId: 'brown',
            image: 'images/bag1.jpg',
            image2: 'images/bag2.jpg',
            image3: 'images/bag3.jpg',
            productDescription:
                'A versatile brown bag perfect for everyday use. Made from high-quality materials, it offers ample space and a sleek design. Whether for work or casual outings, this bag adds a touch of elegance to any outfit.',
        },

        {
            productName: 'GLASSES',
            productPrice: 149,
            productPopularity: 4,
            productId: 'black',
            image: 'images/glassesBlack1.jpg',
            image2: 'images/glassesBlack2.jpg',
            image3: 'images/glassesBlack3.jpg',
            image4: 'images/glassesBlack4.jpg',
            image5: 'images/glassesBlack5.jpg',
            productDescription:
                'These black glasses feature a timeless design suitable for any occasion. Made from high-quality materials, they offer durability and comfort. The classic frame design ensures they remain stylish and versatile.',
        },
        {
            productName: 'GLASSES',
            productPrice: 199,
            productPopularity: 5,
            productId: 'crystal',
            image: 'images/glassesCrystal1.jpg',
            image2: 'images/glassesCrystal2.jpg',
            image3: 'images/glassesCrystal3.jpg',
            productDescription:
                'Stand out with these crystal glasses. The transparent frames add a modern touch, while the high-quality construction ensures durability. Perfect for those who want a unique yet elegant accessory.',
        },
        {
            productName: 'GLASSES',
            productPrice: 249,
            productPopularity: 6,
            productId: 'orange',
            image: 'images/glassesOrange1.jpg',
            image2: 'images/glassesOrange2.jpg',
            image3: 'images/glassesOrange3.jpg',
            image4: 'images/glassesOrange4.jpg',
            image5: 'images/glassesOrange5.jpg',
            productDescription:
                'Add a pop of color to your look with these orange glasses. The vibrant frames are made from durable materials, providing both style and comfort. Ideal for making a bold fashion statement.',
        },

        {
            productName: 'GLASSES',
            productPrice: 399,
            productPopularity: 7,
            productId: 'magma',
            image: 'images/glassesMagma1.jpg',
            image2: 'images/glassesMagma2.jpg',
            image3: 'images/glassesMagma3.jpg',
            image4: 'images/glassesMagma4.jpg',
            image5: 'images/glassesMagma5.jpg',
            productDescription:
                'These magma glasses feature a striking design with a blend of red and black hues. Crafted from high-quality materials, they offer a comfortable fit and a unique look. Perfect for those who want to stand out.',
        },
        {
            productName: 'CAP',
            productPrice: 29,
            productPopularity: 8,
            productId: 'blue',
            image: 'images/cap1.jpg',
            image2: 'images/cap2.jpg',
            image3: 'images/cap3.jpg',
            productDescription:
                'This blue cap is a stylish and practical accessory for any outfit. Made from breathable fabric, it offers comfort and a secure fit. Ideal for casual wear or outdoor activities.',
        },

        {
            productName: 'SCARF',
            productPrice: 49,
            productPopularity: 9,
            productId: 'colorful',
            image: 'images/scarf3.jpg',
            image2: 'images/scarf2.jpg',
            image3: 'images/scarf1.jpg',
            productDescription:
                'Brighten up your wardrobe with this colorful scarf. Made from soft, lightweight fabric, it provides warmth and style. Perfect for adding a splash of color to any outfit.',
        },
        {
            productName: 'BAG',
            productPrice: 109,
            productPopularity: 10,
            productId: 'big',
            image: 'images/bigBag1.jpg',
            image2: 'images/bigBag2.jpg',
            image3: 'images/bigBag3.jpg',
            productDescription:
                'This big bag is perfect for those who need extra space. Made from durable materials, it offers ample storage and a sleek design. Ideal for travel or everyday use.',
        },

        {
            productName: 'BAG',
            productPrice: 79,
            productPopularity: 11,
            productId: 'small',
            image: 'images/smallBag1.jpg',
            image2: 'images/smallBag2.jpg',
            image3: 'images/smallBag3.jpg',
            productDescription:
                'A chic small bag perfect for carrying essentials. Made from high-quality materials, it combines style and functionality. Ideal for both casual and formal occasions.',
        },
        {
            productName: 'BEANIE',
            productPrice: 39,
            productPopularity: 12,
            productId: 'black',
            image: 'images/beanie1.jpg',
            image2: 'images/beanie2.jpg',
            productDescription:
                'Stay warm and stylish with this black beanie. Made from soft, cozy fabric, it offers comfort and a snug fit. Perfect for cold weather.',
        },
        {
            productName: 'CAP',
            productPrice: 29,
            productPopularity: 13,
            productId: 'black',
            image: 'images/capBlack1.jpg',
            image2: 'images/capBlack2.jpg',
            image3: 'images/capBlack3.jpg',
            image4: 'images/capBlack4.jpg',
            productDescription:
                'A classic black cap that complements any outfit. Made from durable materials, it provides comfort and a secure fit. Ideal for everyday wear.',
        },
        {
            productName: 'POUCH',
            productPrice: 89,
            productPopularity: 14,
            productId: 'brown',
            image: 'images/pouchBag1.jpg',
            image2: 'images/pouchBag3.jpg',
            image3: 'images/pouchBag2.jpg',
            image4: 'images/pouchBag4.jpg',
            image5: 'images/pouchBag5.jpg',
            productDescription:
                'This brown pouch is a versatile accessory for carrying small essentials. Made from high-quality materials, it offers a sleek design and ample space. Perfect for both casual and formal occasions.',
        },
        {
            productName: 'RING',
            productPrice: 499,
            productPopularity: 15,
            productId: 'pink',
            image: 'images/ring1.png',
            image2: 'images/ring5.png',
            image3: 'images/ring3.png',
            image4: 'images/ring4.png',
            image5: 'images/ring2.png',
            productDescription:
                'This pink ring features a stunning design with intricate details. Made from high-quality materials, it offers elegance and durability. Ideal for special occasions or as a statement piece.',
        },
        {
            productName: 'WATCH',
            productPrice: 999,
            productPopularity: 19,
            productId: 'GOLD',
            image: 'images/watch1.png',
            image2: 'images/watch5.png',
            image3: 'images/watch2.png',
            image4: 'images/watch4.png',
            image5: 'images/watch3.png',
            productDescription:
                'Elevate your style with this gold watch. Featuring a luxurious design and high-quality craftsmanship, it combines functionality with elegance. Perfect for making a sophisticated statement.',
        },
    ],
    shoes: [
        {
            productName: 'KEY SHOES',
            productPrice: 320,
            productPopularity: 1,
            productId: 'white',
            image: 'https://images.unsplash.com/photo-1579338908476-3a3a1d71a706?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=30',
            image2: 'https://images.unsplash.com/photo-1579338559194-a162d19bf842?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=30',
        },
        {
            productName: 'HYPER SHOES',
            productPrice: 999,
            productPopularity: 2,
            productId: 'special',
            image: 'https://static.nike.com/a/images/t_prod_ss/w_640,c_limit,f_auto/eiff55clouebangd48de/nike-hyperadapt-10-black-white-release-date.jpg',
            image2: 'https://static.nike.com/a/images/t_prod_ss/w_640,c_limit,f_auto/d0oli5pldbuprab5vq5v/nike-hyperadapt-10-black-white-release-date.jpg',
            image3: 'https://static.nike.com/a/images/t_prod_ss/w_640,c_limit,f_auto/mxviutdlph2rypvegdj7/nike-hyperadapt-10-black-white-release-date.jpg',
            image4: 'https://static.nike.com/a/images/t_prod_sc/w_640,c_limit,f_auto/kbhbdbyx6cahri6ai8tb/nike-hyperadapt-10-black-white-release-date.jpg',
            image5: 'https://static.nike.com/a/images/t_prod_ss/w_640,c_limit,f_auto/chjoutckvunhyu0kkcsf/nike-hyperadapt-10-black-white-release-date.jpg',
        },
        {
            productName: 'SBW SHOES',
            productPrice: 450,
            productPopularity: 3,
            productId: 'leather',
            image: 'https://images.unsplash.com/photo-1543508282-6319a3e2621f?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=715&q=30',
            image2: 'https://images.unsplash.com/photo-1543508282-5c1f427f023f?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=715&q=30',
        },
        {
            productName: 'HEELS',
            productPrice: 450,
            productPopularity: 4,
            productId: 'white',
            image: 'https://images.unsplash.com/photo-1518049362265-d5b2a6467637?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=749&q=30',
            image2: 'https://images.unsplash.com/photo-1632793145200-f57458a44005?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=30',
            image3: 'https://images.unsplash.com/photo-1632793039179-8d97795d20c6?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=30',
        },
        {
            productName: 'TIM BOOTS',
            productPrice: 90,
            productPopularity: 5,
            productId: 'wood',
            image: 'https://images.unsplash.com/photo-1520809382381-d95e6364bbdb?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=30',
            image2: 'https://images.unsplash.com/photo-1520640446937-fdfcdc85a6e7?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=30',
            image3: 'https://images.unsplash.com/photo-1520639888713-7851133b1ed0?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=30',
            image4: 'https://images.unsplash.com/photo-1521001750463-5f3e18f2da2d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=30',
            image5: 'https://images.unsplash.com/photo-1542841791-1925b02a2bbb?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=30',
        },
        {
            productName: 'SPECIAL SHOES',
            productPrice: 500,
            productPopularity: 6,
            productId: 'yellow_edition',
            image: 'https://images.unsplash.com/photo-1628253747716-0c4f5c90fdda?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=30',
            image2: 'https://images.unsplash.com/photo-1628253828819-4e1912762afd?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=30',
            image3: 'https://images.unsplash.com/photo-1628254162935-20c03dbae545?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=30',
            image4: 'https://images.unsplash.com/photo-1628254081683-82d5ff0700e1?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=30',
        },
        {
            productName: 'BRD SHOES',
            productPrice: 123,
            productPopularity: 7,
            productId: 'multicolor',
            image: 'https://images.unsplash.com/photo-1597045566677-8cf032ed6634?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=30',
            image2: 'https://images.unsplash.com/photo-1600774236920-66c1d506ad3f?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=30',
            image3: 'https://images.unsplash.com/photo-1521093470119-a3acdc43374a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=30',
            image4: 'https://images.unsplash.com/photo-1609535766154-e47e5aa87789?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=30',
        },
        {
            productName: 'SLIDES',
            productPrice: 70,
            productPopularity: 8,
            productId: 'gray',
            image: 'https://images.unsplash.com/photo-1626771652942-93d834f3d1fd?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=765&q=30',
            image2: 'https://images.unsplash.com/photo-1633281651728-b7f0bd1f3eaa?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=627&q=30',
        },
        {
            productName: 'GOAT SHOES',
            productPrice: 750,
            productPopularity: 9,
            productId: 'black',
            image: 'https://images.unsplash.com/photo-1612723683658-89814a429607?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=764&q=30',
            image2: 'https://images.unsplash.com/photo-1608366558876-185ea88608eb?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=30',
            image3: 'https://images.unsplash.com/photo-1588499894193-2c4dd05b0f09?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=764&q=30',
            image4: 'https://images.unsplash.com/photo-1608366546235-6c683df0c6e0?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=30',
            image5: 'https://images.unsplash.com/photo-1623241681183-80df988067c5?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=686&q=30',
        },
        {
            productName: 'UNIQUE SHOES',
            productPrice: 400,
            productPopularity: 10,
            productId: 'reflective',
            image5: 'https://images.unsplash.com/photo-1636718281461-d6570e49c4b4?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=30',
            image2: 'https://images.unsplash.com/photo-1636718282205-72aa966e1838?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=30',
            image3: 'https://images.unsplash.com/photo-1636718281370-b5e3f51a5af2?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=30',
            image4: 'https://images.unsplash.com/photo-1636718284444-ae1520f1b80e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=30',
            image: 'https://images.unsplash.com/photo-1636718282214-0b4162a154f0?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=765&q=30',
        },
        {
            productName: 'PUFFED SHOES',
            productPrice: 300,
            productPopularity: 11,
            productId: 'gray',
            image: 'https://images.unsplash.com/photo-1542674684-fba3fa06625b?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1974&q=30',
            image2: 'https://images.unsplash.com/photo-1542674684-bb49a27a3d20?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=30',
            image3: 'https://images.unsplash.com/photo-1542674685-07fae978fd57?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=30',
        },
        {
            productName: 'VANS',
            productPrice: 40,
            productPopularity: 12,
            productId: 'classic',
            image: 'https://images.unsplash.com/photo-1610031315213-0ba34a3ff787?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=30',
            image2: 'https://images.unsplash.com/photo-1603994457622-63687030478a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=30',
            image3: 'https://images.unsplash.com/photo-1627778735503-c62e93d7f942?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=30',
            image4: 'https://images.unsplash.com/photo-1563183222-ff776d1076e1?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=30',
        },
        {
            productName: 'CLASSIC',
            productPrice: 100,
            productPopularity: 14,
            productId: 'white',
            image: 'https://images.unsplash.com/photo-1600269452121-4f2416e55c28?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=765&q=30',
            image2: 'https://images.unsplash.com/photo-1615109255406-2a4354fc6b3e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=30',
            image3: 'https://images.unsplash.com/photo-1626379616459-b2ce1d9decbc?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=30',
            image4: 'https://images.unsplash.com/photo-1586197646374-5b33772a8de5?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=627&q=30',
            image5: 'https://images.unsplash.com/photo-1573532006015-013d2bf17ebd?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=30',
        },
        {
            productName: 'ANKLE SHOES',
            productPrice: 80,
            productPopularity: 15,
            productId: 'white',
            image: 'https://images.unsplash.com/photo-1584735174965-48c48d7edfde?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=30',
            image2: 'https://images.unsplash.com/photo-1584735175315-9d5df23860e6?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=30',
            image3: 'https://images.unsplash.com/photo-1584735174914-6b1272458e3e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=30',
            image4: 'https://images.unsplash.com/photo-1584735175077-df669dcd8b0a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=30',
        },
    ],
};

export default productsData;
